// extracted by mini-css-extract-plugin
module.exports = {"inputClass":"LongTextField_inputClass__ZZuLZ","inputElement":"LongTextField_inputElement__3nVPT"};